import { all } from "redux-saga/effects";
import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";
import { saveSubsidiaryLogoWatcher } from "./saveSubsidiaryLogo.saga";

export default function* rootSaga() {
    yield all([getSubsidiariesWatcher(), saveSubsidiaryLogoWatcher()]);
}
